import { DecodedToken } from '../types/decodedToken';

export function hasAdminRole(decodedToken: DecodedToken | null) {
  return Boolean(decodedToken?.realm_access?.roles?.includes('admin'));
}
